import { AppRoute } from './lib/common.types';
import { BillingPageComponent } from './pages/billing-page/billing-page.component';
import { ClaimPageComponent } from './pages/claim-page/claim-page.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { ReportPageComponent } from './pages/report-page/report-page.component';
import { DocumentsPageComponent } from './pages/documents/documents-page/documents-page.component';
import { EmployeePageComponent } from './pages/employee-page/employee-page.component';
import { SearchBySsnComponent } from '@benefitsui/app/pages/employee-page/search-by-ssn/search-by-ssn.component';
import { AllFormsPageComponent } from './pages/form/forms-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { BenefitsCreateClaimComponent } from './pages/claim-page/benefits-create/benefits-create.component';
import { ContactsPageComponent } from './pages/contact-us/contacts-page.component';
import { ClaimsReportPageComponent } from './pages/claim-page/report/claims-report.component';
import { ClaimDetailComponent } from './pages/claim-page/detail/detail.component';
import { ClaimsListComponent } from './pages/claim-page/list/claims-list.component';
import { PremiumComponent } from './pages/billing-page/premium/premium.component';
import { BillingPaymentComponent } from './pages/billing-page/payment/payment.component';
import { BillingListComponent } from './pages/billing-page/list/list.component';
import { BillingFancyPageComponent } from './pages/billing-fancy-page/billing-fancy-page.component';
import { BillingFancyStatementsListComponent } from './pages/billing-fancy-page/statements-list/statements-list.component';
import { StatementDetailsComponent } from './pages/billing-fancy-page/statement-details/statement-details.component';
import { RedirectFormsPageComponent } from './pages/form/redirect-page.component';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { TabBreadcrumbBehavior } from './reusable-components/breadcrumbs/breadcrumb.service';

export const benefitsRoutes: AppRoute[] = [
  {
    path: 'landing',
    text: 'Landing',
    component: LandingPageComponent
  },
  {
    path: 'dashboard',
    text: 'Dashboard',
    data: { hideBreadcrumb: true },
    component: DashboardPageComponent
  },
  {
    path: 'billing',
    text: 'Billing',
    data: { headerText: 'Billing', hideBreadcrumb: true },
    component: BillingPageComponent,
    children: [
      {
        path: '',
        text: 'Billing',
        redirectTo: 'listing',
        pathMatch: 'full'
      },
      {
        path: 'listing',
        text: 'Billing',
        data: { headerText: 'Billing', skipBreadcrumb: true },
        component: BillingListComponent
      },
      {
        path: 'premium',
        text: 'Premium Calculation',
        data: { breadcrumbs: true, headerText: 'Premium calculation' },
        component: PremiumComponent
      },
      {
        path: 'payment',
        text: 'Pay Invoice(s)',
        data: { breadcrumbs: true, headerText: 'Pay invoice(s)' },
        component: BillingPaymentComponent
      }
    ]
  },
  {
    path: 'billing-statements',
    text: 'Billing',
    data: { headerText: 'Billing', skipBreadcrumb: true },
    component: BillingFancyPageComponent,
    children: [
      {
        path: '',
        text: 'Billing',
        redirectTo: 'billing-statements-list',
        pathMatch: 'full'
      },
      {
        path: 'billing-statements-list',
        text: 'Billing',
        data: { headerText: 'Billing' },
        component: BillingFancyStatementsListComponent
      },
      {
        path: 'statement-details',
        text: 'Billing',
        data: { headerText: 'Statement Details' },
        component: StatementDetailsComponent
      }
    ]
  },
  {
    path: 'redirect/forms',
    text: 'Forms',
    data: { headerText: 'Forms' },
    component: RedirectFormsPageComponent
  },
  {
    path: 'employees',
    text: 'n/a - not being used on this page',
    data: { headerText: 'Search employees', hidePageHeader: true },
    component: EmployeePageComponent
  },
  {
    path: 'employees/add',
    text: 'n/a - not being used on this page',
    data: {
      headerText: 'Add employee'
    },
    component: SearchBySsnComponent
  },
  {
    path: 'employees/:id/contracts/:contractId',
    text: 'n/a - not being used on this page',
    component: EmployeePageComponent
  },
  {
    path: 'create',
    text: 'Create New Claim',
    component: BenefitsCreateClaimComponent,
    data: { headerText: 'Create new claim' }
  },
  {
    path: 'claims/report',
    text: 'Claim Reports',
    component: ClaimsReportPageComponent,
    data: { 
      headerText: 'Claim reports'
      // ,enableTabBreadcrumbs: TabBreadcrumbBehavior.Immediate //uncomment if tab breadcrumbs desired
    }
  },
  {
    path: 'claims',
    text: 'Claims',
    data: { headerText: 'Claims Center' },
    component: ClaimPageComponent,
    children: [
      {
        path: '',
        text: 'Claims Redirect',
        redirectTo: 'search',
        pathMatch: 'full'
      },
      {
        path: 'search',
        text: 'Claims',
        data: { headerText: 'Claims Center', skipBreadcrumb: true },
        component: ClaimsListComponent
      },
      {
        path: 'create',
        text: 'Create New Claim',
        component: BenefitsCreateClaimComponent,
        data: { headerText: 'Create new claim' }
      },
      {
        path: ':id',
        text: 'Claim Detail',
        component: ClaimDetailComponent
      }
    ]
  },
  {
    path: 'contacts',
    text: 'Contact Us',
    data: { headerText: 'Contact us' },
    component: ContactsPageComponent
  },
  {
    path: 'report',
    text: 'EOI Report',
    data: { headerText: 'Evidence of insurability (EOI) report' },
    component: ReportPageComponent
  },
  {
    path: 'documents',
    text: 'Contract Documents',
    data: { headerText: 'Contract documents' },
    component: DocumentsPageComponent
  },
  {
    path: 'allforms/:tab',
    text: 'Forms',
    data: { headerText: 'Forms' },
    component: AllFormsPageComponent
  },
  {
    path: 'allforms',
    text: 'Forms',
    data: { headerText: 'Forms' },
    component: AllFormsPageComponent
  }
];
